import { render, staticRenderFns } from "./TodoDetails.vue?vue&type=template&id=8bd62a18&scoped=true"
import script from "./TodoDetails.vue?vue&type=script&lang=js"
export * from "./TodoDetails.vue?vue&type=script&lang=js"
import style0 from "./TodoDetails.vue?vue&type=style&index=0&id=8bd62a18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd62a18",
  null
  
)

export default component.exports